export default __webpack_public_path__ + "static/media/Ies_Lutron.d99e8f77.png";